import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { emailLogsQueries } from '@/services/emailLogs/emailLogs.queries';
import { useSearch } from '@tanstack/react-router';

export const useEmailLogsList = () => {
  const { createdDate, page, fetch, q } = useSearch({
    from: '/(app)/logs-management/email-logs/',
  });

  const parsedCreatedDate = parseDateRangeSearch(createdDate);

  const { data, isLoading } = useQuery({
    ...emailLogsQueries.list({
      fromDate: parsedCreatedDate.start,
      toDate: parsedCreatedDate.end,
      row: page,
      fetch,
      search: q,
    }),
  });

  return {
    emailLogs: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
